import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import InfiniteCalendar from 'react-infinite-calendar';
import {
  AppBar,
  Grid,
  Paper,
  Switch,
  Toolbar,
  Typography,
} from '@material-ui/core';
import {
  setSelectedStartDate,
  showHolidays as showHolidaysAction,
} from './../../redux/actions/newOperationHoursActions';
import './../Fields/Calendar/styles/infiniteCalendarStyles.css';
import './../Fields/Calendar/styles/infiniteCustomStyles.css';
import { removeHolidayToolTip, removeEventListenersForToolTip, createHolidayEvent } from '../../utils/utils';

export const localesMap = {
  ara: require('react-infinite-calendar/node_modules/date-fns/locale/ar'),
  cze: require('react-infinite-calendar/node_modules/date-fns/locale/cs'),
  dan: require('react-infinite-calendar/node_modules/date-fns/locale/da'),
  ger: require('react-infinite-calendar/node_modules/date-fns/locale/de'),
  eng: require('react-infinite-calendar/node_modules/date-fns/locale/en'),
  spa: require('react-infinite-calendar/node_modules/date-fns/locale/es'),
  spl: require('react-infinite-calendar/node_modules/date-fns/locale/es'),
  fil: require('react-infinite-calendar/node_modules/date-fns/locale/fil'),
  fre: require('react-infinite-calendar/node_modules/date-fns/locale/fr'),
  frc: require('react-infinite-calendar/node_modules/date-fns/locale/fr'),
  ind: require('react-infinite-calendar/node_modules/date-fns/locale/id'),
  ita: require('react-infinite-calendar/node_modules/date-fns/locale/it'),
  jpn: require('react-infinite-calendar/node_modules/date-fns/locale/ja'),
  kor: require('react-infinite-calendar/node_modules/date-fns/locale/ko'),
  dut: require('react-infinite-calendar/node_modules/date-fns/locale/nl'),
  ptb: require('react-infinite-calendar/node_modules/date-fns/locale/pt'),
  rus: require('react-infinite-calendar/node_modules/date-fns/locale/ru'),
  swe: require('react-infinite-calendar/node_modules/date-fns/locale/sv'),
  tai: require('react-infinite-calendar/node_modules/date-fns/locale/th'),
  tur: require('react-infinite-calendar/node_modules/date-fns/locale/tr'),
  chs: require('react-infinite-calendar/node_modules/date-fns/locale/zh_cn'),
  cht: require('react-infinite-calendar/node_modules/date-fns/locale/zh_tw'),
};
const useStyles = (RestaurantId) =>
  makeStyles((theme: Theme) =>
    createStyles({
      root: {
        flexGrow: 1,
      },
      paperCalendar: {
        textAlign: 'left',
        height: !RestaurantId ? '64.5vh' : '60vh',
        overflow: 'hidden',
      },
      calendarFooter: {
        float: 'right',
      },
      holidayTypography: {
        marginTop: '1%',
        marginLeft: '5%',
        color: 'black',
      },
      holidaySwitch: {
        marginLeft: '25%',
      },
    }),
  )


export default function OperationHoursCalendar({ RestaurantId }) {
  const { t } = useTranslation();
  const classes = useStyles(RestaurantId)();
  const dispatch: any = useDispatch();

  const holidays = useSelector(
    (state: RootStateOrAny) => state.HolidaysReducer.holidays,
  );
  const { showHolidays, selectedStartDate } = useSelector(
    (state: RootStateOrAny) => state.NewOperationHoursReducer,
  );
  const { selectedLanguage } = useSelector(
    (state: RootStateOrAny) => state.AppReducer.selectedLanguage,
  );

  const createHolidayMarkers = () => {
    holidays.forEach(element => {
      const dateSelected: any = document.querySelectorAll(
        `[data-date="${element.date}"]`,
      );
      if (dateSelected[0]) {
        createHolidayEvent(element.date, dateSelected[0], t(`app.common.holydays.${element.alias_name}`, element.holiday));
      }
    });
  };

  const removeHolidayMarkers = () => {
    let holidaysSelected = document.querySelectorAll(
      `[data-type-holiday-event]`,
    );
    removeEventListenersForToolTip();
    if (holidaysSelected[0]) {
      holidaysSelected.forEach(element => {
        element.removeAttribute('data-type-holiday-event');
        element.querySelector('[data-type-holiday="Holiday"]')?.remove();
      });
    }
    removeHolidayToolTip();
  };

  const onSelectDate = selectedDate => {
    const date = moment(selectedDate).startOf('day');
    dispatch(setSelectedStartDate(date));
  };

  const updateHolidayMarkers = () => {
    removeHolidayMarkers();
    if (showHolidays) {
      createHolidayMarkers();
    }
  };

  const scrollTimeOut = () => {
    let timeOut;
    window.clearTimeout(timeOut);
    timeOut = setTimeout(() => {
      updateHolidayMarkers();
    }, 300);
  };

  useEffect(() => {
    updateHolidayMarkers();
  }, [holidays, showHolidays]);

  useEffect(() => {
    return () => {
      // removeEventListenersForToolTip();
      updateHolidayMarkers();
    }
  })
  return (
    <React.Fragment>
      <Paper className={classes.paperCalendar}>
        <Grid item xs={12}>
          <InfiniteCalendar
            theme={{
              selectionColor: 'rgb(162, 162, 162)',
              headerColor: 'rgb(138, 138, 138)',
              weekdayColor: 'rgb(216, 216, 216)',
            }}
            locale={{
              locale:
                localesMap[
                selectedLanguage ||
                localStorage.getItem('selectedLanguage') ||
                'en'
                ],
              blank: t('app.common.calendar.selectADate'),
              headerFormat: 'MMM Do',
              todayLabel: {
                long: t('app.common.calendar.today', 'today'),
                short: t('app.common.calendar.today', 'Today'),
              },
              weekdays: [
                t('app.common.calendar.sunday_short', 'sun'),
                t('app.common.calendar.monday_short', 'mon'),
                t('app.common.calendar.tuesday_short', 'ttue'),
                t('app.common.calendar.wednesday_short', 'wed'),
                t('app.common.calendar.thursday_short', 'thu'),
                t('app.common.calendar.friday_short', 'fri'),
                t('app.common.calendar.saturday_short', 'sat'),
              ],
              weekStartsOn: 0,
            }}
            width={'100%'}
            height={350}
            rowHeight={50}
            selected={
              selectedStartDate ? selectedStartDate.format('YYYY-MM-DD') : new Date()
            }
            onSelect={onSelectDate}
            onScroll={scrollTimeOut}
          />
        </Grid>
      </Paper>
      <AppBar
        elevation={1}
        position="static"
        style={{ backgroundColor: 'white' }}
      >
        {RestaurantId && <Toolbar variant="dense">
          <Grid container className={classes.calendarFooter}>
            <Grid item xs={9}>
              <Typography className={classes.holidayTypography}>
                {t('operationHours.displayHolidays')}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Switch
                className={classes.holidaySwitch}
                name="checkedHolidays"
                color="default"
                checked={showHolidays}
                onChange={() => dispatch(showHolidaysAction(!showHolidays))}
              />
            </Grid>
          </Grid>
        </Toolbar>}
      </AppBar>
    </React.Fragment>
  );
}
